import { localePath, useI18n } from '../i18n';
import { Container, RegisterRow } from '../ui';
import { BrandLogo } from './BrandLogo';
import { FOOTER_NAV } from './navigation';

export function Footer() {
  const { locale, t, formatNumber } = useI18n();

  return (
    /*
      Solid Ink, the dark semantic tier scoped to the footer: the logo re-inks
      itself to White and every token below reads its dark value. No gradient —
      the identity is flat fills and hard edges.
    */
    <footer data-theme="dark" className="hs-band mt-auto">
      <Container>
        <div className="flex flex-col gap-10 py-16">
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-[1.4fr_1fr_1fr]">
            <div className="max-w-sm">
              {/*
                The horizontal lockup, reversed by the theme, with the brand
                descriptor beneath it: logo, then descriptor, in that order.
              */}
              <BrandLogo className="h-9 w-auto" />
              <p className="mt-5 max-w-[34ch] text-sm text-text-muted">
                {t('common.brand.tagline')}
              </p>
            </div>

            {FOOTER_NAV.map((column) => (
              <nav key={column.headingKey} aria-label={t(column.headingKey)}>
                <h2 className="hs-overline mb-4 text-text">{t(column.headingKey)}</h2>
                {/*
                  `py-1.5` on the links, not on the column: a bare 14px line is
                  a 20px tap target, and on a phone these links are the last
                  navigation on the page. The padding takes each to 32px — past
                  the 24px WCAG 2.5.8 asks for.
                */}
                <div className="flex flex-col gap-0.5">
                  {column.items.map((item) => (
                    <a
                      key={item.path}
                      href={localePath(locale, item.path)}
                      className="py-1.5 text-sm text-text-muted transition-colors hover:text-text"
                    >
                      {t(item.labelKey)}
                    </a>
                  ))}
                </div>
              </nav>
            ))}
          </div>

          <div className="flex flex-col gap-6">
            {/* A register row as the footer's divider: the identity's one
                decorative element, with no carry — the logo above has it. */}
            <RegisterRow className="h-2 w-auto self-start" />
            <p className="text-sm text-text-muted">
              {/*
                The year is formatted through the locale formatter rather than
                interpolated raw, so the numbering system is a decision made once
                in packages/i18n-messages and not per component.
              */}
              {t('common.footer.copyright', {
                year: formatNumber(new Date().getFullYear(), { useGrouping: false }),
              })}
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
}
